import { render, staticRenderFns } from "./app_contact.vue?vue&type=template&id=2bef03f6&scoped=true&"
import script from "./app_contact.vue?vue&type=script&lang=js&"
export * from "./app_contact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bef03f6",
  null
  
)

export default component.exports